import { memo, useMemo } from "react";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";

// custom components
import SearchNotFound from "../SearchNotFound";
import DatatableActions from "./DatatableActions";

function DatatableBody({
  bodyData,
  page,
  rowsPerPage,
  selectedData,
  onRowSelected,
  selectedColumnName,
  columnAlign,
  onRowEdit,
  renderCell,
  actions,
  emptyRows,
  isDataNotFound,
  filterText,
  columnSchema,
  onRowDelete,
  primaryKey,
  columnWidths = {},
}) {
  const slicedBodyData = useMemo(() => {
    return bodyData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [bodyData, rowsPerPage, page]);

  return (
    <>
      <TableBody>
        {slicedBodyData.map((body) => (
          <TableRow
            hover
            key={body.id}
            tabIndex={-1}
            role="checkbox"
            selected={selectedData.indexOf(body[selectedColumnName]) !== -1}
            aria-checked={selectedData.indexOf(body[selectedColumnName]) !== -1}
          >
            <TableCell padding="checkbox" style={{ width: '48px' }}>
              <Checkbox
                checked={selectedData.indexOf(body[selectedColumnName]) !== -1}
                onChange={(event) =>
                  onRowSelected(event, body[selectedColumnName])
                }
              />
            </TableCell>
            {columnSchema.map((schema) => {
              const columnWidth = columnWidths[schema] || 150;
              return (
                <TableCell 
                  key={`${body.id || JSON.stringify(body)}-${schema}`} 
                  align={columnAlign}
                  style={{ 
                    width: columnWidth,
                    maxWidth: columnWidth,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {renderCell(body[schema], schema, body)}
                </TableCell>
              );
            })}
            {actions && (
              <TableCell align="right" style={{ width: '120px' }}>
                <DatatableActions
                  row={body}
                  onTableRowDelete={onRowDelete}
                  onTableRowEdit={onRowEdit}
                />
              </TableCell>
            )}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableRow>
        ))}
      </TableBody>
      {isDataNotFound && (
        <TableBody>
          <TableRow>
            <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
              <SearchNotFound searchQuery={filterText} />
            </TableCell>
          </TableRow>
        </TableBody>
      )}
    </>
  );
}

DatatableBody.defaultProps = {
  bodyData: [],
  page: 0,
  rowsPerPage: 5,
  selectedData: [],
  selectedColumnName: "id",
  columnAlign: "left",
  onRowSelected: () => {},
  emptyRows: 0,
  isDataNotFound: false,
  filterText: "",
  columnSchema: [],
  primaryKey: "",
  renderCell: (col) => col,
  onRowDelete: () => {},
  onRowEdit: () => {},
  columnWidths: {},
  actions: false,
};

export default memo(DatatableBody);
